import { gql } from "@apollo/client";

export const DELETE_RISK_SCORE_ADJUSTMENT = gql`
  mutation deleteRiskScoreAdjustment($input: DeleteForClientByIdInput!) {
    aml {
      deleteRiskScoreAdjustment(input: $input) {
        success
      }
    }
  }
`;
